import React, { useEffect, useState } from "react";
import "./TopButton.css";

export default function TopButton({ theme }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.pageYOffset > 360);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goUp = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      className={`route-top-button ${visible ? "is-visible" : ""}`}
      onClick={goUp}
      title="Back to top"
      aria-label="Back to top"
      style={{
        "--top-accent": theme.imageHighlight,
        "--top-panel": theme.body,
        "--top-text": theme.text,
      }}
    >
      <span>↑</span>
      <i>TOP</i>
    </button>
  );
}
